import { Routes } from '@angular/router';

import { canActivateAuthorized, canMatchAuthorized } from './core/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages-core/auth-pages/auth-pages.module').then((m) => m.AuthPagesModule),
  },
  {
    path: '',
    loadChildren: () => import('./pages-core/client-pages/client-pages.module').then((m) => m.ClientPagesModule),
    canActivate: [canActivateAuthorized],
    canMatch: [canMatchAuthorized],
  },
];
